"use client";

import { passkeyClient } from "@better-auth/passkey/client";
import { adminClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
	baseURL: typeof window !== "undefined" ? window.location.origin : "",
	plugins: [passkeyClient(), adminClient()],
});

export const { signIn, signOut, signUp, useSession } = authClient;
